import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-registration-verifying-email',
    templateUrl: './registration-verifying-email.component.html',
    styleUrls: ['./registration-verifying-email.component.scss'],
    imports: [MatInputModule, MatButtonModule, MatIconModule]
})
export class RegistrationVerifyingEmailComponent implements OnInit, OnDestroy {
  content: any;
  private destroy$ = new Subject<void>();
  constructor(private contentService: SignUpContentServiceService) {}
  ngOnInit() {
    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
